import React from 'react'

const CheckoutTotal = (props) => {
    const price = props.price;
    const originalPrice = props.originalPrice;

    return (
        <div className='checkouttotal__container'>
            <div className="checkouttotal__line">

            </div>

            <div className="checkouttotal__flexcontainer">
                <div className="checkouttotal__title">
                    Total
                </div>

                <div className="checkouttotal__pricecontainer">
                    <div className="checkouttotal__currency">
                        USD
                    </div>

                    <div className="checkouttotal__price">
                        {originalPrice && <span className="checkouttotal__originalprice">{originalPrice}</span>}
                        {price}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CheckoutTotal